import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { ContentBlockType } from '@onesource/schemas';
import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useResolvedBlock } from '#/features/community-hub/components/block-viewers/use-resolved-block';
import { LessonBreadcrumbs } from '#/features/community-hub/components/lesson-breadcrumbs';
import { VideoBlockPlayer } from '#/features/community-hub/components/lesson-detail-view/video-block-player';

/**
 * Video item viewer. Path: /programs/{program}/video/{itemSlug}
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/video/$itemSlug')({
  component: VideoContentRoute,
});

function VideoContentRoute() {
  const { itemSlug } = Route.useParams();
  const {
    programId,
    moduleId,
    lessonId,
    programSlug,
    moduleSlug,
    lessonSlug,
    lesson,
    module,
    findParentLesson,
    block,
    isLoading,
    error,
  } = useResolvedBlock(itemSlug, ContentBlockType.VIMEO);

  const handleClose = useCallback(() => {
    window.history.back();
  }, []);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">Failed to load content: {error.message}</Alert>
      </Box>
    );
  }

  if (!block) {
    return (
      <Box p={3}>
        <Alert severity="error">Video not found</Alert>
      </Box>
    );
  }

  return (
    <Box>
      <LessonBreadcrumbs
        spaceId={programId}
        moduleId={moduleId}
        lessonId={lessonId}
        module={module}
        lesson={lesson}
        parentLesson={findParentLesson}
        currentLabel="Video"
        programSlug={programSlug}
        moduleSlug={moduleSlug}
        lessonSlug={lessonSlug}
      />

      <Box sx={{ width: { xs: '100%', md: 'calc(100% - 190px)' } }}>
        <VideoBlockPlayer block={block} lessonId={lessonId} onClose={handleClose} />
      </Box>
    </Box>
  );
}
